import FilterBar from "Components/Common/FilterBar/FilterBar";
import AreaFilterCard from "Components/Common/FilterBar/FilterCards/AreaFilterCard/AreaFilterCard";
import RoleFilterCard from "Components/Common/FilterBar/FilterCards/RoleFilterCard/RoleFilterCard";
import YesNoFilterCard from "Components/Common/FilterBar/FilterCards/YesNoFilterCard/YesNoFilterCard";
import i18n from "i18next";
import { Area } from "Models/Areas/Area";
import { RoleType } from "Models/Users/RoleType";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuditTemplateAction } from "Store/AuditTemplates/AuditTemplateAction";
import { AuditTemplateFilterState } from "Store/AuditTemplates/AuditTemplateFilterState";
import { IAuditTemplateState } from "Store/AuditTemplates/AuditTemplateState";
import { IApplicationState } from "Store/Store";

const auditTemplateAction = ServiceProvider.get<IAuditTemplateAction>(Types.IAuditTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getAuditTemplatesByFilterAsync: (filterState: AuditTemplateFilterState) =>
        dispatch(auditTemplateAction.getAuditTemplatesByFilterAsync(filterState, true)),
});

const mapStateToProps = (state: IApplicationState) => ({
    auditTemplateState: state.auditTemplateState
});

interface IProps {
    auditTemplateState: IAuditTemplateState;
    getAuditTemplatesByFilterAsync: (filterState: AuditTemplateFilterState) => Action;
}

interface IState {
    selectedArea?: Area;
    selectedRoles: RoleType[];
    instructionsAttached?: boolean;
    photoAttached?: boolean;
}

export class AuditTemplateFilters extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    public static readonly DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        if (this.props.auditTemplateState.currentFilter) {
            this.state = {
                selectedArea: this.props.auditTemplateState.currentFilter.area,
                selectedRoles: this.props.auditTemplateState.currentFilter.roles || [],
                instructionsAttached: this.props.auditTemplateState.currentFilter.instructionsAttached,
                photoAttached: this.props.auditTemplateState.currentFilter.photoAttached
            };
        }
        else {
            this.state = {
                selectedRoles: []
            };
        }

        this.onChangeRoles = this.onChangeRoles.bind(this);
        this.onChangeInstructionAttached = this.onChangeInstructionAttached.bind(this);
        this.onChangePhotoAttached = this.onChangePhotoAttached.bind(this);
        this.onChangeArea = this.onChangeArea.bind(this);
        this.clear = this.clear.bind(this);
    }

    public onChangeRoles(selectedRoles: RoleType[]) {
        this.setState({
            selectedRoles
        });

        this.filter();
    }

    public onChangeInstructionAttached(value?: boolean) {
        this.setState({
            instructionsAttached: value
        });

        this.filter();
    }

    public onChangePhotoAttached(value?: boolean) {
        this.setState({
            photoAttached: value
        });

        this.filter();
    }

    public onChangeArea(area?: Area) {
        this.setState({
            selectedArea: area
        });

        this.filter();
    }

    public filter() {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }

        const debounceFunction = () => {
            const filter: AuditTemplateFilterState = {
                ...this.props.auditTemplateState.currentFilter,
                area: this.state.selectedArea,
                roles: this.state.selectedRoles,
                instructionsAttached: this.state.instructionsAttached,
                photoAttached: this.state.photoAttached,
                skip: 0
            };
            this.props.getAuditTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), AuditTemplateFilters.DEBOUNCE_TIMEOUT);
    }

    public clear() {
        this.setState({
            selectedArea: undefined,
            selectedRoles: [],
            instructionsAttached: undefined,
            photoAttached: undefined
        });
        this.filter();
    }

    public render() {
        return (
            <FilterBar onClear={this.clear}>
                <AreaFilterCard onSelectArea={this.onChangeArea} selectedArea={this.state.selectedArea} />
                <RoleFilterCard selectedRoles={this.state.selectedRoles} onChange={this.onChangeRoles} />
                <YesNoFilterCard title={i18n.t("tasks.filters.instructionsAttached")} value={this.state.instructionsAttached} onChange={this.onChangeInstructionAttached} />
                <YesNoFilterCard title={i18n.t("tasks.filters.photoAttached")} value={this.state.photoAttached} onChange={this.onChangePhotoAttached} />
            </FilterBar>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditTemplateFilters);


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateFilters/AuditTemplateFilters.tsx